import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import IconSvg from "./IconSvg";
import stl from "./OrderPaidMessage.module.css";
import useHelpers from "@hooks/useHelpers";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
var OrderPaidMessage = function OrderPaidMessage(_ref) {
  var order_id = _ref.order_id;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ReservedMessageWrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconSvg, null), /*#__PURE__*/React.createElement("strong", null, t("error_apologize", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("Order Already Paid", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "".concat(stl.btn, " blueBtn"),
    onClick: function onClick() {
      navigateTo("/tracking-checkout-details/".concat(order_id));
    }
  }, t("order_tracking", {
    ns: "web_checkout_cash"
  }))));
};
export default OrderPaidMessage;